<template>
    <DataTable
        :header="header"
        :items="items"
        :fields="fields"
        :pagination="false"
        show-export-button
    >
        <template #cell(campaign)="{item}">
            <b-link class="nowrap d-flex align-items-center gap-1 line-height-1" target="_blank" :href="item.campaignUrl">
                <ImageLoader :src="item.campaignIcon" :size="14" /> {{ item.campaign }}
            </b-link>
        </template>
        <template #cell(name)="{item}">
            <b-link class="nowrap d-flex align-items-center gap-1 line-height-1" target="_blank" :href="item.url">
                {{ item.name }} <feather type="external-link" :size="14" />
            </b-link>
        </template>
        <template #cell(price)="{item}">
            <div class="nowrap">
                {{ $format.currency(item.price) }}
            </div>
            <div class="nowrap font-size-11 text-secondary">
                {{ $format.datetime(item.date) }}
            </div>
        </template>
    </DataTable>
</template>



<script>
    import DataTable from '@/components/common/DataTable.vue';
    import ImageLoader from '@/components/common/ImageLoader.vue';

    export default {
        name: 'OfferListDataTable',
        components: {
            DataTable,
            ImageLoader,
        },
        props: {
            items: {
                type: [Array, Function],
                required: true,
            },
            header: {
                type: String,
                required: true,
            },
        },
        computed: {
            fields() {
                return [
                    {
                        key: 'campaign',
                        label: this.$t('campaign'),
                        sortable: true,
                        exportable: true,
                    },
                    {
                        key: 'name',
                        label: this.$t('offer'),
                        sortable: true,
                        exportable: true,
                    },
                    {
                        key: 'date',
                        label: this.$t('date'),
                        sortable: true,
                        exportable: true,
                        show: false,
                        formatter: val => this.$format.datetime(val),
                    },
                    {
                        key: 'price',
                        label: this.$t('price'),
                        exportLabel: `${this.$t('price')} [${process.env.VUE_APP_SYSTEM_CURRENCY}]`,
                        sortable: true,
                        exportable: true,
                        tdClass: 'text-right text-nowrap',
                        thClass: 'text-right',
                    },
                ];
            },
        },
    };
</script>
